import React from "react";
import { Link } from "react-router-dom";

export default function Hero() {
  return (
    <section className="relative bg-center bg-no-repeat bg-cover bg-[url('http://reportcmr.friedenapps.ng/police.jpg')] min-h-[75vh] flex items-center">
      {/* Dark overlay for high contrast readability */}
      <div className="absolute inset-0 bg-slate-900/80"></div>

      <div className="relative z-10 px-4 py-16 mx-auto max-w-screen-xl sm:px-6 lg:px-8 w-full flex flex-col justify-center">
        <div className="max-w-2xl text-center sm:text-left">
          <h1 className="text-4xl font-extrabold tracking-tight text-white sm:text-5xl lg:text-6xl">
            Nigeria Police Force
            <span className="block mt-2 text-yellow-400">
              Stolen Vehicle Portal
            </span>
          </h1>

          <p className="max-w-lg mt-6 text-lg text-gray-200 leading-relaxed font-medium">
            Protecting citizens' property is our priority. Report stolen and unrecovered vehicles (from January 1st, 2018 to present) directly to the NPF database to aid nationwide recovery efforts.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mt-10 justify-center sm:justify-start">
            <Link
              to="/stolen"
              className="inline-flex justify-center items-center px-8 py-4 text-base font-bold text-slate-900 bg-yellow-400 rounded-lg shadow-lg hover:bg-yellow-500 transition-colors focus:ring-4 focus:ring-yellow-400/50"
            >
              Report Stolen Vehicle
            </Link>
            
            <Link
              to="/about"
              className="inline-flex justify-center items-center px-8 py-4 text-base font-semibold text-white bg-white/10 border border-white/20 rounded-lg hover:bg-white/20 backdrop-blur-sm transition-colors focus:ring-4 focus:ring-white/30"
            >
              Learn More
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}